<template lang="pug">
    sectionHeader(title="formula")
        .section-header--action.action-formula(slot="action")
            button.btn.btn-simple.btn-add-and(
                title="add AND"
                @click="formula.addInclustionBox()",
            )
                svg-icon(name="add" size="small")
                span.txt-and AND

            button.btn.btn-simple.btn-add-not(
                :class="{ 'is-disabled': formula.exclusionBoxes.length > 0 }",
                title="add NOT"
                @click="formula.addExclusionBox()",
            )
                svg-icon(name="add", size="small")
                span.txt-not NOT

            button.btn.btn-simple(
                :class="{ 'is-disabled': formula.isOnInitialState }",
                title="Reset formula"
                @click="resetFormula()"
            )
                svg-icon(name="trash" size="small")
                span Clear formula
</template>

<script>
import SectionHeader from '@/components/common/SectionHeader'

export default {
    name: 'FormulaHeader',

    components: {
        SectionHeader
    },

    props: {
        formula: {
            type: Object,
            required: true
        }
    },

    methods: {
        resetFormula() {
            this.$msgbox
                .confirm('You are about to clear the formula, do you want to continue ?', 'Warning', {
                    type: 'warning',
                    confirmButtonText: 'Continue',
                    cancelButtonText: 'Cancel'
                })
                .then(() => {
                    this.formula.initializeFormula()
                    this.formula.setRecency(30)
                    this.formula.setQuantile(10)
                    this.formula.setSurfIntensity(0)
                    this.formula.defaultQuantile.disable()
                    this.formula.defaultSurfIntensity.disable()
                }).catch(e => e)
        }
    }
}
</script>
